import KnowledgeHubFiles from '@/modules/Workspaces/KnowledgeHub/Files/KnowledgeHubFiles.vue'
import HubPage from '@/modules/Workspaces/KnowledgeHub/Hubs/HubPage.vue'
import HubsListPage from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsListPage.vue'
import KnowledgeHubIntro from '@/modules/Workspaces/KnowledgeHub/Intro/KnowledgeHubIntro.vue'
import KnowledgeHubHome from '@/modules/Workspaces/KnowledgeHub/KnowledgeHubHome.vue'
import TopBar from '@/modules/Workspaces/KnowledgeHub/Layout/NavigationBar.vue'
import { showKnowledgeHubIntro } from '@/modules/Workspaces/KnowledgeHub/preferences'
import type { RouteRecordRaw } from 'vue-router'

const knowledgeHubRoute: RouteRecordRaw = {
  path: 'knowledge-hub',
  name: 'KnowledgeHub',
  redirect() {
    return { name: showKnowledgeHubIntro.value ? 'KnowledgeHubIntro' : 'Files' }
  },
  children: [
    {
      path: 'welcome',
      name: 'KnowledgeHubIntro',
      components: { BreadCrumbs: TopBar, default: KnowledgeHubIntro },
      props: { BreadCrumbs: { hideLinks: true } },
    },
    {
      path: 'integrations',
      name: 'Integrations',
      components: { BreadCrumbs: TopBar, default: KnowledgeHubHome },
      props: { BreadCrumbs: { hideLinks: false } },
    },
    {
      path: 'hubs',
      redirect: { name: 'Hubs' },
      props: { BreadCrumbs: { hideLinks: false } },
      children: [
        {
          path: '',
          name: 'Hubs',
          components: { BreadCrumbs: TopBar, default: HubsListPage },
          props: { BreadCrumbs: { hideLinks: false } },
        },
        {
          path: ':hubId',
          name: 'Hub',
          components: { BreadCrumbs: TopBar, default: HubPage },
          props: { BreadCrumbs: { hideLinks: false } },
        },
      ],
    },
    {
      path: 'files',
      name: 'Files',
      components: { BreadCrumbs: TopBar, default: KnowledgeHubFiles },
      props: { BreadCrumbs: { hideLinks: false } },
    },
  ],
}

export const knowledgeHubRoutes: RouteRecordRaw[] = [knowledgeHubRoute]
